import { API } from "./api";

export const addEntertainmentVideo = (videos) =>
  API.post(`/entertainmentVideos`, videos);
export const getAllEntertainmentVideos = () => API.get(`/entertainmentVideos`);
export const getEntertainmentVideoById = (videoId) =>
  API.get(`entertainmentVideos/${videoId}`);

export const updateEntertainmentVideo = (videoId, video) =>
  API.put(`/entertainmentVideos/${videoId}`, video);

export const deleteEntertainmentVideo = (videoId) =>
  API.delete(`/entertainmentVideos/${videoId}`);

export const getAdminScreensForVideo = (type, locationId) =>
  API.get(`screens/type/?type=${type}&locationId=${locationId}`);
